import { Component } from "@angular/core";
import { NavController } from "@ionic/angular";
import { CustomerModel } from "src/app/models/customer-model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import { GameSettingsService } from "src/app/services/game-settings/game-settings.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";

@Component({
  selector: "app-game-settings",
  templateUrl: "./game-settings.component.html",
  styleUrls: ["./game-settings.component.scss"],
})

export class GameSettingsComponent {
  public error = null;
  public settings: any = {};
  public canSave: boolean = false;
  public playSounds: boolean = false;
  public useFourColorDeck: boolean = false;
  public isSportsApp: boolean = false;
  public sessionStats;
  public sessionStatsOptions: any;

  constructor(
    protected config: ConfigService,
    public navCtrl: NavController,
    public settingsProvider: GameSettingsService,
    public userService: UserSessionService,
    public authenticationService: AuthenticationService,
    public successMessageService: SuccessMessageService
  ) {
    this.successMessageService.clearMessage();
    this.isSportsApp = this.config.isSportsApp();
  }

  ionViewDidEnter() {
    this.sessionStatsOptions = JSON.parse(this.config.getConfig().FEATURE_STATS_SETTINGS ?? '[{"label": "15 Minutes","value": "15"},{"label": "30 Minutes","value": "30"}]');
    this.sessionStats = this.config.getConfig().sessionStatsDefault ?? "60";
    this.onGetSettings();
  }

  onUpdateSettings() {
    this.canSave = true;
    this.successMessageService.clearMessage();
  }

  onGetSettings() {
    this.userService.getCustomer().subscribe((customer: CustomerModel) => {
      if (customer) {
        if (
          null !== customer.getCustomDataProperty("PUSH_STATS_INTERVAL_MIN")
        ) {
          this.sessionStats = customer.getCustomDataProperty(
            "PUSH_STATS_INTERVAL_MIN"
          );
        }
      }
    });

    this.settingsProvider.getSettings().subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          this.settings = response.payload;
          if (this.settings.play_sounds == "1") {
            this.playSounds = true;
          } else {
            this.playSounds = false;
          }

          if (this.settings.use_four_color_deck == "1") {
            this.useFourColorDeck = true;
          } else {
            this.useFourColorDeck = false;
          }
        }
      },
      error: (error) => {
        this.error = error;
      }
    });
  }

  onSaveSettings() {
    this.canSave = false;

    // system settings
    const system_settings: any = [];
    system_settings["propName"] = "PUSH_STATS_INTERVAL_MIN";
    system_settings["propValue"] = this.sessionStats;
    this.authenticationService
      .updateCustomData(system_settings)
      .subscribe((resp) => {
        this.userService.refreshCustomer();
      });

    // game settings
    const game_settings: any = {};
    game_settings.play_sounds = this.playSounds == true ? "1" : "0";
    game_settings.use_four_color_deck =
      this.useFourColorDeck == true ? "1" : "0";

    this.settingsProvider.setSettings(game_settings).subscribe((resp) => {
      if (resp.result == 1) {
        this.userService.refreshCustomer();
        this.successMessageService.setMessage("Your settings have been saved.");
      }
    });
  }
}
